import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'

import { Href } from 'components/navigation'
import { Image, Text } from 'components/dataDisplay'

import s from './ServiceCard.scss'


const ServiceCard = ({ className, title, text, to, image, imagePosition }) => {
  const { isMobile, isTablet } = useDevice()

  return (
    <Href className={className} to={to}>
      <div
        className={cx(s.gradientBackground, s.marketplaceCard, 'flex radius-24 overflow-hidden', {
          'justify-end': isMobile,
          'justify-between': !isMobile,
        })}
      >
        {
          !isMobile && (
            <div className={cx('flex flex-col ml-24px', isTablet ? 'my-36px mw-276' : 'my-24px')}>
              <Text
                message={title}
                size="h24"
                color="titanic"
              />
              <Text
                className={cx(s.secondLineClamp, s.text, 'mt-8px overflow-ellipsis webkit-box opacity-72')}
                message={text}
                size="t16-24"
                color="titanic"
              />
            </div>
          )
        }
        <div
          className={cx('flex', {
            'ml-40px': !isMobile,
            'items-center': imagePosition === 'center' && !isMobile,
            'items-end': imagePosition === 'bottom' || isMobile,
          })}
        >
          <Image src={image} width={isMobile ? '158' : isTablet ? '154' : '172'} />
        </div>
      </div>
      {
        isMobile && (
          <Text
            className="mt-8px text-center"
            message={title}
            size="c16"
            color="titanic"
          />
        )
      }
    </Href>
  )
}


export default ServiceCard
